import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminTemplate, Button } from "../../components";
import MerchantBlacklistHistoryTable from "../../../src/components/organisms/merchant/MerchantBlacklistHistoryTable";

export const MerchantBlacklistHistoryPage = () => {

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Kara Liste Tarihçe",
        hideAddButton: true,
      }}
    >
      <MerchantBlacklistHistoryTable />
    </AdminTemplate>
  );
};
